// actions/test-maintenance/remove.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function removeHasErrored(bool) {
  return {
    type: 'U_REMOVE_TEST_M_HAS_ERRORED',
    hasErrored: bool
  };
}

export function removeIsLoading(bool) {
  return {
    type: 'U_REMOVE_TEST_M_IS_LOADING',
    isLoading: bool
  };
}

export function removeFetchDataSuccess(resp) {
  return {
    type: 'U_REMOVE_TEST_M_FETCH_DATA_SUCCESS',
    resp
  };
}

export function removeFetchData(host, body) {
  return (dispatch) => {
    dispatch(removeIsLoading(true));
    dispatch(removeHasErrored(false));
    fetch(host + 'admin/untouchables/remove', {
      method: 'post',
      body: JSON.stringify(body),
      headers: attachAuth()
    }).then(promise => {
      if (!promise.ok) {
        throw Error(promise.statusText);
      }
      
      dispatch(removeIsLoading(false));
      promise.json()
        .then(result => {
          dispatch(removeFetchDataSuccess(result))
          PubSub.publish('test.maintenance.remove', result);
        })
        .catch((e) => {
          console.log(e);
          dispatch(removeHasErrored(true))
        });
      })
      .catch((e) => {
        console.log(e);
          dispatch(removeIsLoading(false));
          dispatch(removeHasErrored(true));
      });
  };
}